import {DOC_VERIFIED} from './DocVerifyType';

const initialState= {
    documentsVerified: false
}

const docverifyReducer = (state=initialState,action) => {
    switch(action.type)
    {
        case DOC_VERIFIED: return {
            ...state,
            documentsVerified: action.documentsVerified
        }
        default: return state
    }
}

export default docverifyReducer;